import a from"./fails.js";import l from"./global.js";var e=a,o=l,t=o.RegExp,p=e(function(){var r=t(".","s");return!(r.dotAll&&r.exec(`
`)&&r.flags==="s")});export{p as default};
